import { defineComponent as _defineComponent } from 'vue'

import { computed } from 'vue';
import FormattedNumber, { formattedNumberProps } from 'ah-common-lib/src/number/FormattedNumber.vue';
import { useTradesCurrencyFormatter } from './useTradesCurrencyFormatter';

/**
 * FormattedCurrencyValue component for use within ah-trades
 *
 * FIXME after ah-wallets/ah-trades/ah-beneficiaries/ah-reports merge,
 * this should be replaced with a component common to all 4 subpackages
 */

const { formatter, prefixLabel, ...reducedProps } = formattedNumberProps;

export default /*#__PURE__*/_defineComponent({
  __name: 'TradesFormattedCurrency',
  props: {
  ...reducedProps,
  currency: {
    type: String,
    required: true,
  },
  withPrefix: {
    type: [String, Boolean],
    default: true,
  },
},
  setup(__props) {

const props = __props;



const formatter = useTradesCurrencyFormatter({
  currency: computed(() => props.currency),
});

return { __sfc: true,formatter, prefixLabel, reducedProps, props, FormattedNumber }
}

})